(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ecCom"), require("mobx"), require("antd"), require("React"), require("comsMobx"), require("ReactDOM"), require("weaCowork"));
	else if(typeof define === 'function' && define.amd)
		define(["ecCom", "mobx", "antd", "React", "comsMobx", "ReactDOM", "weaCowork"], factory);
	else if(typeof exports === 'object')
		exports["weaCowork"] = factory(require("ecCom"), require("mobx"), require("antd"), require("React"), require("comsMobx"), require("ReactDOM"), require("weaCowork"));
	else
		root["weaCowork"] = factory(root["ecCom"], root["mobx"], root["antd"], root["React"], root["comsMobx"], root["ReactDOM"], root["weaCowork"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_155__, __WEBPACK_EXTERNAL_MODULE_427__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition